import { Link } from 'react-router-dom';
import NewsCard from '@/components/feature/NewsCard';
import { newsList } from '@/mocks/news';

export default function HomeNewsSection() {
  const items = newsList.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-md bg-accent-500 text-white flex items-center justify-center">
            <i className="ri-newspaper-line text-xl"></i>
          </span>
          <div>
            <p className="text-xs text-foreground-500 font-label uppercase tracking-widest">Latest News</p>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">最新影视资讯</h2>
          </div>
        </div>
        <Link
          to="/news"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((item) => (
          <NewsCard key={item.id} item={item} layout="list" />
        ))}
      </div>

      <Link
        to="/news"
        className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-600 font-medium"
      >
        查看全部资讯 <i className="ri-arrow-right-line"></i>
      </Link>
    </section>
  );
}